<div class="menu-list-new menu-list-new--options js-component-content">
    @for (item of collection; track item) {
		<div
			class="menu-list-new__item"
			(click)="onItemSelect(item)"
			(pointerenter)="onPointerEnter(item, $event)">
			<skl-menu-item-option
				class="display--contents display-edge--contents-flex"
				[item]="item">
			</skl-menu-item-option>
		</div>
    }
</div>
